import React, {memo, useEffect, useState} from "react";
import {message} from "antd";
import {
    TablesEnum,
    useGetCoursesWithPaginationQuery,
} from "../../../../generated/graphql";
import {useLocalStorageOptions} from "../../../../helpers/columnsLocalStorageHandler";
import {CourseTableData} from "../../../../containers/courses/CourseEdit/CourseListSelection/baseSetupVariables";
import CourseListSelection from "../../../../containers/courses/CourseEdit/CourseListSelection/CourseListSelection";

type AddCourseSelectorProps = {
    bookingRestrictionId?: string;
    currentCourseId: string;
    selectedCourseIds: Array<string>;
    // setSelectedCourseIds: ({courseIds}: {courseIds: Array<string>}) => void;
    // const setSelectedCourseIds: React.Dispatch<React.SetStateAction<string[]>>
    setSelectedCourseIds: (courseIds: Array<string>) => void;
    // setSelectedCourseIds: () => void
};

const AddCourseSelector = ({
    bookingRestrictionId,
    currentCourseId,
    selectedCourseIds,
    setSelectedCourseIds,
}: AddCourseSelectorProps) => {
    const tablesEnum = TablesEnum.CourseSelectPrerequisiteCourses;
    const [totalResults, setTotalResults] = useState<number>(0);
    const [options, setOptions] = useLocalStorageOptions({
        localStorageName: tablesEnum,
        defaultOptions: {},
        totalResults,
    });
    const excludedCourseIds = currentCourseId ? [currentCourseId] : undefined;
    const {data, loading, error, refetch} = useGetCoursesWithPaginationQuery({
        variables: {
            options,
            excludedCourseIds,
        },
        fetchPolicy: "network-only",
    });
    const tableData: CourseTableData = {
        dataSource: data?.coursesWithPagination.items ?? [],
        existMore: data?.coursesWithPagination.existsMore,
        total: data?.coursesWithPagination.total,
        loading,
    };

    const handleCourseSelection = (selectedIds: Array<string>) => {
        // console.group("handleCourseSelection");
        // console.log(selectedIds);
        // console.groupEnd();
        setSelectedCourseIds(selectedIds);
    };

    useEffect(() => {
        if (data?.coursesWithPagination.total) {
            setTotalResults(data.coursesWithPagination.total);
        }
    }, [data]);

    if (error) {
        console.error(error);
        message.error(error.message);

        return <div>{error.message}</div>;
    }

    return (
        <CourseListSelection
            tableData={tableData}
            options={options}
            setOptions={setOptions}
            refetch={refetch}
            tablesEnum={tablesEnum}
            toolBarButtons={[]}
            tableTitle="Freigabekurse wählen"
            defaultColumns={[
                "prefixedCourseNumber",
                "courseType",
                "firstCourseLesson",
            ]}
            handleCourseSelection={handleCourseSelection}
            selectedCourseIds={selectedCourseIds}
            selectionType="checkbox"
            liftRowSelection={(selection) => handleCourseSelection(selection)}
            showHeader={false}
            renderWithoutPage
        />
    );
};

export default memo(AddCourseSelector);
